var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vuex-table',{attrs:{"fields":_vm.fields,"show_per_page":false,"auto_start":false,"select_filter_message":_vm.$t('shared.component.table.need_select_filter'),"table_store":"phone-number/numbers/buy"},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('numbers-buy-table-cell-action',{attrs:{"item":item}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }